export function calculateAge(dateOfBirth) {
    if (!dateOfBirth) return "N/A";

    const today = new Date();
    let birthDate;

    // Parse date in local timezone to avoid timezone offset issues
    if (dateOfBirth instanceof Date) {
      // If it's already a Date object (from MongoDB), use it directly
      birthDate = dateOfBirth;
    } else if (typeof dateOfBirth === 'string') {
      // If it's a string, parse it with timezone handling
      // Check if it already has time component
      if (dateOfBirth.includes('T')) {
        birthDate = new Date(dateOfBirth);
      } else {
        birthDate = new Date(dateOfBirth + 'T00:00:00');
      }
    } else {
      // Fallback for other types
      birthDate = new Date(dateOfBirth);
    }

    // Check if the date is valid
    if (isNaN(birthDate.getTime())) {
      return "N/A";
    }

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    // Check if the birthday hasn't occurred yet this year
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return isNaN(age) ? "N/A" : age;
  }